import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Prescription, DrugProduct } from '@fusion-advantage/backcompat'
import { defaultDrugIcdDataSet, DrugIcdCodeDataSet, PrescriptionHistoryItem } from '@fusion-advantage/formlib'
import _ from "lodash"

export interface DrugSliceState {
	models: Prescription[]
	icdCodeDataSet: DrugIcdCodeDataSet
	drugList: DrugProduct[]
	history: PrescriptionHistoryItem[]
}

const initialState: DrugSliceState = {
	models: [],
	icdCodeDataSet: defaultDrugIcdDataSet(),
	drugList: [],
	history: [],
}

const drugSlice = createSlice({
	name: 'drug',
	initialState,
	reducers: {
		loadDrugIcdDataSet(state, action: PayloadAction<DrugIcdCodeDataSet>) {
			state.icdCodeDataSet = action.payload
		},
		setPrescriptions(state, action: PayloadAction<Prescription[]>) {
			state.models = action.payload
		},
		setDrugProducts(state, action: PayloadAction<DrugProduct[]>) {
			state.drugList = action.payload
		},
		setPrescriptionHistory(state, action: PayloadAction<PrescriptionHistoryItem[]>) {
			state.history = action.payload
		},
	}
})

export const { loadDrugIcdDataSet, setPrescriptions, setDrugProducts, setPrescriptionHistory } = drugSlice.actions
export default drugSlice.reducer
